import MewsStandalone from './standalone';
import MewsWidget from './widget';

class BookingEngineFactory {
	/**
	 * Constructor
	 *
	 * @param {Object} options Configuration options
	 */
	constructor(options) {
		this.options = options;
	}

	/**
	 * Get the booking engine class.
	 *
	 * @returns {Object} The Mews bookingengine class for the selected mode.
	 */
	createBookingEngine() {
		switch (this.options.mode) {
			case 'standalone':
				return new MewsStandalone(this.options);
			case 'widget':
				return new MewsWidget(this.options);
			default:
				return new MewsWidget(this.options);
		}
	}
}

export { MewsWidget as default, BookingEngineFactory };
